export default "__VITE_ASSET__CT8IZekh__"